import { Typography } from "@mui/material";
import TimeService from "@services/timeService/timeService";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import { Tooltip } from "@shared/Tooltip";

type DateCellProps = {
    value: string | number | null | undefined;
    width?: number;
    onClick?: () => void;
    /** How the incoming value is encoded. Device-reported timestamps arrive as epoch millis, not ISO. */
    sourceFormat?: "ISO" | "MILLIS" | "SECONDS";
};

export const DateCell = ({ sourceFormat = "ISO", ...props }: DateCellProps) => {
    if (!props.value) {
        return (
            <MinimalTableCell width={props.width} onClick={props.onClick}>
                <Typography>-</Typography>
            </MinimalTableCell>
        );
    }

    const displayDate = TimeService.getLocalDate(props.value, sourceFormat, "date");
    const fullDateTime = TimeService.getLocalDate(props.value, sourceFormat, "dateTime");

    return (
        <MinimalTableCell width={props.width} onClick={props.onClick}>
            <Tooltip title={fullDateTime}>
                <Typography>{displayDate}</Typography>
            </Tooltip>
        </MinimalTableCell>
    );
};
